export default __webpack_public_path__ + "static/media/biomassa.9c8dfa47.jpg";